export default function appendErrorMessage(errorDescription: string, e: unknown) {
	if (e instanceof Error) {
		return errorDescription + ": " + e.message
	}
	return errorDescription
}
